export const JUTE_BATCH_PLANNING_LIST = "jute_batch_planning_list";
export const JUTE_BATCH_PLANNING_LIST_SUCCESSFULL = "jute_batch_planning_list_successfull";
export const JUTE_PLAN_ASSIGN = "jute_plan_assign";
export const JUTE_PLAN_ASSIGN_SUCCESSFULL = "jute_plan_assign_successfull";
// export const JUTE_GATE_ENTRY_LINE_ITEMS = "jute_gate_entry_line_items";
// export const JUTE_GATE_ENTRY_CREATE = "jute_gate_entry_create";
// export const JUTE_GATE_ENTRY_VIEW_BY_ID = "jute_gate_entry_view_by_id";
// export const JUTE_GATE_ENTRY_VIEW_BY_ID_SCCESSFULL = "jute_gate_entry_view_by_id_successfull";
